<app-standard-data-table
    (gridRequested)="gridRequested($event)"
    [source]="groupUsers"
    [sorts]="[{ prop: 'displayName', dir: 'asc' }]"
    [columns]="columns$ | async"
    [noRecordsMessage]="'administration.userManagement.noRecordsMessage' | translation | async"
></app-standard-data-table>

<ng-template #commandsTemplate let-row="row">
    <a [ngbTooltip]="'actions.delete' | translation | async" placement="left" (click)="emitDelete(row)">
        <span class="delete-icon default-icon-color"></span>
    </a>
</ng-template>
